import { createAsyncThunk } from '@reduxjs/toolkit';
import estimateSettingApi from '~/apis/estimateSetting';
import {
  CREATE_DETAILS_TEMPLATE,
  CREATE_ESTIMATE_LAYOUT,
  CREATE_INTRODUCTION_TEMPLATE,
  GET_ESTIMATE_LAYOUTS,
  GET_ESTIMATE_TEMPLATES,
  CREATE_SIGNING_UPGRADES,
  GET_ESTIMATE_TEMPLATE_INTRODUCTION,
  GET_ESTIMATE_TEMPLATE_AUTHORIZATION
} from '~/utils/constants/actionType';
import {
  IPayloadCreateDetailsTemplate,
  IPayloadCreateIntroductionTemplate,
  IResponseGetEstimateLayouts,
  IResponseGetEstimateTemplateAuthorization,
  IResponseGetEstimateTemplateIntroduction,
  IResponseGetEstimateTemplates,
  SigningUpgradesFormData
} from '~/utils/interface/estimateSetting';

export const handleGetEstimateLayouts = createAsyncThunk<IResponseGetEstimateLayouts>(
  GET_ESTIMATE_LAYOUTS,
  async (_, { rejectWithValue }) => {
    try {
      const res = await estimateSettingApi.getEstimateLayouts();
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleCreateEstimateLayout = createAsyncThunk<any, any>(
  CREATE_ESTIMATE_LAYOUT,
  async (data, { rejectWithValue }) => {
    try {
      const res = await estimateSettingApi.createEstimateLayout(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetEstimateTemplates = createAsyncThunk<IResponseGetEstimateTemplates>(
  GET_ESTIMATE_TEMPLATES,
  async (_, { rejectWithValue }) => {
    try {
      const res = await estimateSettingApi.getEstimateTemplates();
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleCreateIntroductionTemplate = createAsyncThunk<any, IPayloadCreateIntroductionTemplate>(
  CREATE_INTRODUCTION_TEMPLATE,
  async (data, { rejectWithValue }) => {
    try {
      const res = await estimateSettingApi.createIntroductionTemplate(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleCreateDetailsTemplate = createAsyncThunk<any, IPayloadCreateDetailsTemplate>(
  CREATE_DETAILS_TEMPLATE,
  async (data, { rejectWithValue }) => {
    try {
      const res = await estimateSettingApi.createDetailsTemplate(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleCreateSigningUpgrades = createAsyncThunk<any, SigningUpgradesFormData>(
  CREATE_SIGNING_UPGRADES,
  async (data, { rejectWithValue }) => {
    try {
      const res = await estimateSettingApi.signingUpgrades(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetEstimateTemplateIntroduction = createAsyncThunk<IResponseGetEstimateTemplateIntroduction>(
  GET_ESTIMATE_TEMPLATE_INTRODUCTION,
  async (_, { rejectWithValue }) => {
    try {
      const res = await estimateSettingApi.getEstimateTemplateIntroduction();
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetEstimateTemplateAuthorization = createAsyncThunk<IResponseGetEstimateTemplateAuthorization>(
  GET_ESTIMATE_TEMPLATE_AUTHORIZATION,
  async (_, { rejectWithValue }) => {
    try {
      const res = await estimateSettingApi.getEstimateTemplateAuthorization();
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);